module.exports = __webpack_public_path__ + "static/img/image036.d30ae3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image036.png
// module id = lx5q
// module chunks = 1